import * as moment from 'moment';
import { DateConverter } from 'src/app/core/services/mapper/converters';

export class Campagne {
    static jsonMap = {
        id: { key: 'id' },
        code: { key: 'code', optional: true, default: '' },
        libelle: { key: 'libelle', optional: true, default: '' },
        annee: { key: 'annee' },
        dateDebutAnpp: { key: 'dateDebutAnpp', converter: new DateConverter() },
        dateFinAnpp: { key: 'dateFinAnpp', converter: new DateConverter() },
        dateDebut: { key: 'dateDebut', converter: new DateConverter() },
        dateFin: { key: 'dateFin', converter: new DateConverter() }
    };

    id: number;
    code: string;
    libelle: string;
    annee: number = undefined;
    dateDebutAnpp: moment.Moment;
    dateFinAnpp: moment.Moment;
    dateDebut: moment.Moment;
    dateFin: moment.Moment;
}
